import { faBars } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { MobileMenuContainer } from "../../containers/MobileMenuContainer";
import { Flex } from "../Flex";
import { Icon } from "../Icon";

interface Props {
  serviceCatalogueNav?: boolean;
}

export const MobileActionBar: React.FC<Props> = ({ serviceCatalogueNav }) => {
  const [showMenu, setShowMenu] = useState<boolean>(false);

  const handleOpenMenu = () => setShowMenu(prevShowMenu => !prevShowMenu);

  return (
    <>
      <Flex
        bg="primary"
        mr="12px"
        pl={1}
        justifyContent="space-between"
        alignContent="center"
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          onClick={handleOpenMenu}
        >
          <Icon
            icon={faBars}
            opacity={0.8}
            fontSize={6}
            color="white"
            data-testid="hamburger-menu"
            cursor="pointer"
          />
        </Flex>
      </Flex>
      <MobileMenuContainer
        show={showMenu}
        onClose={handleOpenMenu}
        serviceCatalogueNav={serviceCatalogueNav}
      />
    </>
  );
};
